export default __webpack_public_path__ + "static/media/feedback_bcg.f9cce278.svg";